import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@dexio/common';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  getDocumentHistory(documentId: string) {
    return this.http
      .get(`${this.configs.get().apiUrl}/admin/documents/${documentId}/history`);
  }
  getFriendlyDocumentHistory(documentId: string) {
    return this.http
      .get(`${this.configs.get().apiUrl}/admin/documents/${documentId}/friendlyhistory`);
  }
  unassign(documentId: string) {
    return this.http
      .post(`${this.configs.get().apiUrl}/admin/documents/${documentId}/unassign`,{});
  }
  sendToErrorQueue(documentId: string) {
    return this.http
      .post(`${this.configs.get().apiUrl}/admin/documents/${documentId}/sendToError`,{});
  }
  search(projectId: string, term: string) {
    return this.http.get(`${this.configs.get().apiUrl}/projects/${projectId}/documents/search?q=${term}`);
  }
}
